module.exports = __webpack_public_path__ + "static/media/10.f2ba2c64.mp3";